export const getReservesData = async (id, page = 2) => {
	try {
		const res = await fetch(`/api/exchanges/reserves?id=${id}&page=${page}`);
		return res.json();
	} catch (error) {
		console.error(error);
	}
};
